import storeRatings from '../data/storeRatings.json';
// Voice showcase images - all character images from mobile app (exact mapping)
const albus = require('../components/images/albus.jpeg');
const sage = require('../components/images/sage.jpeg');
const optimus = require('../components/images/optimus.jpeg');
const walker = require('../components/images/walker.jpeg');
const arthur = require('../components/images/arthur.jpeg');
const nova = require('../components/images/nova.jpeg');
const ash = require('../components/images/ash.jpeg');
const queen = require('../components/images/queen.jpeg');
const cherry = require('../components/images/cherry.jpeg');
const beth = require('../components/images/beth.jpeg');
const juggernaut = require('../components/images/juggernaut.jpeg');
const captain = require('../components/images/captain.jpeg');
const jane = require('../components/images/jane.jpeg');
const percy = require('../components/images/percy.jpeg');
const juni = require('../components/images/juni.jpeg');
const william = require('../components/images/william.jpeg');
const atlas = require('../components/images/atlas.jpeg');
const orin = require('../components/images/orin.jpeg');
const boots = require('../components/images/boots.jpeg');
const rufus = require('../components/images/rufus.jpeg');
const terry = require('../components/images/lucky.jpeg');
const fiona = require('../components/images/fiona.jpeg');
const miles = require('../components/images/miles.jpeg');
const finn = require('../components/images/finn.jpeg');
const anna = require('../components/images/anna.jpeg');
const samantha = require('../components/images/samantha.jpeg');
const polly = require('../components/images/polly.jpeg');
const khali = require('../components/images/khali.jpeg');
const quinn = require('../components/images/quinn.jpeg');
const amelia = require('../components/images/amelia.jpeg');
const dash = require('../components/images/dash.jpeg');
const malrog = require('../components/images/malrog.jpeg');
const britney = require('../components/images/britney.jpeg');

// Voice audio files - using mobile app voice files
const albusAudio = require('../components/voices/albus.mp3');
const sageAudio = require('../components/voices/sage.mp3');
const optimusAudio = require('../components/voices/optimus.mp3');
const walkerAudio = require('../components/voices/walker.mp3');
const arthurAudio = require('../components/voices/arthur.mp3');
const novaAudio = require('../components/voices/nova.mp3');
const ashAudio = require('../components/voices/ash.mp3');
const queenAudio = require('../components/voices/queen.mp3');
const shimmerAudio = require('../components/voices/shimmer.mp3');
const bethAudio = require('../components/voices/beth.mp3');
const ragnarAudio = require('../components/voices/ragnar.mp3');
const captainAudio = require('../components/voices/captain.mp3');
const janeAudio = require('../components/voices/jane.mp3');
const percyAudio = require('../components/voices/percy.mp3');
const juniAudio = require('../components/voices/juni.mp3');
const williamAudio = require('../components/voices/william.mp3');
const atlasAudio = require('../components/voices/atlas.mp3');
const orinAudio = require('../components/voices/orin.mp3');
const onyxAudio = require('../components/voices/onyx.mp3');
const fableAudio = require('../components/voices/fable.mp3');
const balladAudio = require('../components/voices/ballad.mp3');
const fionaAudio = require('../components/voices/fiona.mp3');
const echoAudio = require('../components/voices/echo.mp3');
const coralAudio = require('../components/voices/coral.mp3');
const annaAudio = require('../components/voices/anna.mp3');
const rubyAudio = require('../components/voices/ruby.mp3');
const pollyAudio = require('../components/voices/polly.mp3');
const khaliAudio = require('../components/voices/khali.mp3');
const ameliaAudio = require('../components/voices/amelia.mp3');
const quinnAudio = require('../components/voices/quinn.mp3');
const dashAudio = require('../components/voices/dash.mp3');
const malrogAudio = require('../components/voices/malrog.mp3');
const britneyAudio = require('../components/voices/britney.mp3');

// Story style images - from public/art_styles folder (referenced as absolute paths)
const style3DCartoon = '/art_styles/boy_cartoon.jpeg';
const styleWatercolor = '/art_styles/boy_watercolor.jpeg';
const stylePixel = '/art_styles/boy_pixel.jpeg';
const styleWool = '/art_styles/boy_woolknit.jpeg';
const styleAnime = '/art_styles/boy_anime.jpeg';
const styleClaymation = '/art_styles/boy_claymation.jpeg';
const stylePhotoRealism = '/art_styles/boy_real.jpeg';
const styleComicBook = '/art_styles/boy_comic.jpeg';
const styleMinecraft = '/art_styles/boy_lego.jpeg';
const styleChildrensBook = '/art_styles/boy_storybook.jpeg';
const styleSugarpop = '/art_styles/boy_sugerpop.jpeg';
const styleSprayPaint = '/art_styles/boy_spray_paint.jpeg';
const styleCrayon = '/art_styles/boy_crayon.jpeg';
const styleSketch = '/art_styles/boy_sketch.jpeg';
const styleOrigami = '/art_styles/boy_origami.jpeg';
const styleInkToon = '/art_styles/ink_toon.jpeg';
const styleHDGame = '/art_styles/aaa_game.jpeg';
const styleCozyPainting = '/art_styles/cozy_paint.jpeg';

// Featured stories data
export const stories = [
    {
        imageUrl: require('../components/images/storythumbnails/scribblehero.jpeg'),
        title: "The Scribble Hero",
        storyId: "f9feef23-5a22-43b1-a5fc-e3123bbc59b7",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "f9feef23-5a22-43b1-a5fc-e3123bbc59b7",
        styleId: "anime"
    },
    {
        imageUrl: require('../components/images/storythumbnails/pixelprincessquest.jpeg'),
        title: "Pixel Princess Quest",
        storyId: "b44cbff0-9e26-4e1a-9589-8da70bd2b75d",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "b44cbff0-9e26-4e1a-9589-8da70bd2b75d",
        styleId: "pixel"
    },
    {
        imageUrl: require('../components/images/storythumbnails/bubblegum.jpeg'),
        title: "The Bubblegum Dragon",
        storyId: "bbbd95c6-3b86-43bc-9062-3abad0c6e119",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "bbbd95c6-3b86-43bc-9062-3abad0c6e119",
        styleId: "3d-cartoon"
    },
  {
    imageUrl: require('../components/images/storythumbnails/sloth.jpeg'),
    title: "Super Sloth Saves the Day",
    storyId: "23238420-764d-4ccf-a9aa-808e050096f5",
    userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
    chapterIds: "23238420-764d-4ccf-a9aa-808e050096f5",
    styleId: "3d-cartoon"
},
    {
        imageUrl: '/story-thumbnails/watchthemagicunfold.jpg',
        title: "Watch the Magic Unfold",
        storyId: "e3edb288-65f8-4ce5-8ce3-c0bafca2309b",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "",
        styleId: "ink-toon",
        detailPath: "/story-details/ink-toon/e3edb288-65f8-4ce5-8ce3-c0bafca2309b",
        watchPath: "/story?storyId=e3edb288-65f8-4ce5-8ce3-c0bafca2309b&userId=d46046ba-8cb0-45be-b338-5f6f98b6a223&chapterIds=&fromHomepage=true"
    },
    {
        imageUrl: require('../components/images/storythumbnails/cloudpainter.jpeg'),
        title: "The Cloud Painter",
        storyId: "9ea32394-44c8-4abf-9946-3caf9c796f89",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "9ea32394-44c8-4abf-9946-3caf9c796f89",
        styleId: "watercolor"
    },
    {
      imageUrl: require('../components/images/storythumbnails/rainbowunbrella.jpeg'),
      title: "The Rainbow Umbrella",
      storyId: "241cdf7a-ed86-4173-ab6b-dce0d9f865cc",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      chapterIds: "241cdf7a-ed86-4173-ab6b-dce0d9f865cc",
      styleId: "watercolor"
  },

  {
      imageUrl: require('../components/images/storythumbnails/bannanabandit.jpeg'),
      title: "Banana Bandit vs. Captain Peel",
      storyId: "d1151fb7-fd68-435c-8e51-b51eab7c8ebc",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      chapterIds: "d1151fb7-fd68-435c-8e51-b51eab7c8ebc",
      styleId: "comic-book"
  },
    {
        imageUrl: require('../components/images/storythumbnails/timetravelingtoast.jpeg'),
        title: "Time-Traveling Toast",
        storyId: "11b2d0ee-5100-4a91-9f7f-42052513dded",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "11b2d0ee-5100-4a91-9f7f-42052513dded",
        styleId: "anime"
    },
    {
        imageUrl: require('../components/images/storythumbnails/buildacastle.jpeg'),
        title: "Build-a-Castle Race",
        storyId: "ae144c4d-3954-4284-a08d-79a28d640b9f",
        userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
        chapterIds: "ae144c4d-3954-4284-a08d-79a28d640b9f",
        styleId: "minecraft"
    }
];

// Voice showcase data - updated to match mobile app voices with correct images
export const voiceData = [
  {
    narrator: 'sir-albus',
    label: 'Sir Albus',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: albus,
    audioFile: albusAudio,
    bgColor: 'linear-gradient(135deg, #f7faff, #e1ecfa)'
  },
  {
    narrator: 'sage',
    label: 'Sage',
    tone: 'Mystic_Spell_Caster',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with mystical reverence, dramatic magical flourishes, and a sense of ancient wisdom.',
    image: sage,
    audioFile: sageAudio,
    bgColor: 'linear-gradient(135deg, #c2eabb, #8fc36d)'
  },
  {
    narrator: 'optimus',
    label: 'Optimus',
    tone: 'Cheerful_Android',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a robotic yet cheerful voice with mechanical undertones.',
    image: optimus,
    audioFile: optimusAudio,
    bgColor: 'linear-gradient(135deg, #88cfff, #3f87c7)'
  },
  {
    narrator: 'ms-walker',
    label: 'Ms. Walker',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, motherly voice perfect for bedtime stories.',
    image: walker,
    audioFile: walkerAudio,
    bgColor: 'linear-gradient(135deg, #f5ebd9, #e6d7b8)'
  },
  {
    narrator: 'king-arthur',
    label: 'King Arthur',
    tone: 'Gallant_Knight',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with noble conviction, courage and honor. Add a touch of medieval heroism.',
    image: arthur,
    audioFile: arthurAudio,
    bgColor: 'linear-gradient(135deg, #e8b545, #bf8923)'
  },
  {
    narrator: 'penny-snow',
    label: 'Penny Snow',
    tone: 'Curious_Cosmic_Explorer',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with an otherworldly, slightly high-pitched curious tone with unusual speech patterns.',
    image: nova,
    audioFile: novaAudio,
    bgColor: 'linear-gradient(135deg, #58d0f7, #0072b5)'
  },
  {
    narrator: 'ash',
    label: 'Ash',
    tone: 'Calm_And_Soothing',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a calm, measured, and deeply relaxing voice that puts the listener at ease.',
    image: ash,
    audioFile: ashAudio,
    bgColor: 'linear-gradient(135deg, #f7faff, #e1ecfa)'
  },
  {
    narrator: 'queen-bee',
    label: 'Queen Bee',
    tone: 'Theatrical_Drama_Queen',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with dramatic flair and theatrical presence.',
    image: queen,
    audioFile: queenAudio,
    bgColor: 'linear-gradient(135deg, #d4a657, #9e7b34)'
  },
  {
    narrator: 'cherry-twinkle',
    label: 'Cherry Twinkel',
    tone: 'Bouncing_Sugar_Rocket',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with extreme enthusiasm, high energy, and rapid delivery. Add squeals of excitement.',
    image: cherry,
    audioFile: shimmerAudio,
    bgColor: 'linear-gradient(135deg, #f5ebd9, #e6d7b8)'
  },
  {
    narrator: 'aunt-beth',
    label: 'Aunt Beth',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a warm, nurturing aunt-like voice.',
    image: beth,
    audioFile: bethAudio,
    bgColor: 'linear-gradient(135deg, #ffa8ac, #ff7a80)'
  },
  {
    narrator: 'lord-ragnar',
    label: 'Lord Ragnar',
    tone: 'Diabolical_Lord',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a deep, powerful, commanding voice.',
    image: juggernaut,
    audioFile: ragnarAudio,
    bgColor: 'linear-gradient(135deg, #545454, #232323)'
  },
  {
    narrator: 'captain-flint',
    label: 'Captain Flint',
    tone: 'Campfire_Tale_Whisperer',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a hushed, suspenseful tone with dramatic pauses, as if telling a spooky story around a campfire.',
    image: captain,
    audioFile: captainAudio,
    bgColor: 'linear-gradient(135deg, #ffb980, #e87a32)'
  },
  {
    narrator: 'nimble',
    label: 'Nimble',
    tone: 'Buzzing_Prize_Announcer',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with high energy and excitement like a game show host.',
    image: jane,
    audioFile: janeAudio,
    bgColor: 'linear-gradient(135deg, #88cfff, #3f87c7)'
  },
  {
    narrator: 'master-percy',
    label: 'Master Percy',
    tone: 'Mystic_Spell_Caster',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with wisdom and mystical knowledge.',
    image: percy,
    audioFile: percyAudio,
    bgColor: 'linear-gradient(135deg, #c2eabb, #8fc36d)'
  },
  {
    narrator: 'juni',
    label: 'Juni',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, youthful voice perfect for bedtime stories.',
    image: juni,
    audioFile: juniAudio,
    bgColor: 'linear-gradient(135deg, #f7faff, #e1ecfa)'
  },
  {
    narrator: 'detective-gadget',
    label: 'Detective Gadget',
    tone: 'True_Crime_Buff',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a serious, investigative tone with dramatic emphasis on key details, like a true crime podcast host.',
    image: william,
    audioFile: williamAudio,
    bgColor: 'linear-gradient(135deg, #545454, #232323)'
  },
  {
    narrator: 'atlas',
    label: 'Atlas',
    tone: 'Heroic_Warrior',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a deep greek god voice zuess brave warrior protagonist in an epic story. Convey strength, courage, and determination.',
    image: atlas,
    audioFile: atlasAudio,
    bgColor: 'linear-gradient(135deg, #e8b545, #bf8923)'
  },
  {
    narrator: 'orin-stormvale',
    label: 'Orin Stormvale',
    tone: 'Mystic_Spell_Caster',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with ancient wisdom and mystical power.',
    image: orin,
    audioFile: orinAudio,
    bgColor: 'linear-gradient(135deg, #c2eabb, #8fc36d)'
  },
  {
    narrator: 'boots',
    label: 'Boots',
    tone: 'True_Crime_Buff',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a serious, investigative tone with dramatic emphasis on key details, like a true crime podcast host.',
    image: boots,
    audioFile: onyxAudio,
    bgColor: 'linear-gradient(135deg, #545454, #232323)'
  },
  {
    narrator: 'lucian',
    label: 'Lucian',
    tone: 'Gallant_Knight',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with noble conviction, courage and honor. Add a touch of medieval heroism.',
    image: rufus,
    audioFile: fableAudio,
    bgColor: 'linear-gradient(135deg, #d8e8ff, #9cc3ff)'
  },
  {
    narrator: 'lucky-mcguire',
    label: 'Lucky McGuire',
    tone: 'Campfire_Tale_Whisperer',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a hushed, suspenseful tone with dramatic pauses, as if telling a spooky story around a campfire.',
    image: terry,
    audioFile: balladAudio,
    bgColor: 'linear-gradient(135deg, #ffb980, #e87a32)'
  },
  {
    narrator: 'fiona',
    label: 'Fiona',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: fiona,
    audioFile: fionaAudio,
    bgColor: 'linear-gradient(135deg, #ffa8ac, #ff7a80)'
  },
  {
    narrator: 'dexter-dynamite',
    label: 'Dexter Dynamite',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: miles,
    audioFile: echoAudio,
    bgColor: 'linear-gradient(135deg, #88cfff, #3f87c7)'
  },
  {
    narrator: 'finn',
    label: 'Finn',
    tone: 'Mellow_Surfer',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a relaxed, laid-back tone with extended vowels and a carefree attitude.',
    image: finn,
    audioFile: coralAudio,
    bgColor: 'linear-gradient(135deg, #ffa8ac, #ff7a80)'
  },
  {
    narrator: 'princess-anna',
    label: 'Princess Anna',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a royal, elegant voice with grace and poise.',
    image: anna,
    audioFile: annaAudio,
    bgColor: 'linear-gradient(135deg, #f7faff, #e1ecfa)'
  },
  {
    narrator: 'ruby',
    label: 'Ruby',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: samantha,
    audioFile: rubyAudio,
    bgColor: 'linear-gradient(135deg, #ffa8ac, #ff7a80)'
  },
  {
    narrator: 'polly',
    label: 'Polly',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: polly,
    audioFile: pollyAudio,
    bgColor: 'linear-gradient(135deg, #f5ebd9, #e6d7b8)'
  },
  {
    narrator: 'empress-khali',
    label: 'Empress Khali',
    tone: 'Snappy_Sass_Machine',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with quick, witty delivery and sarcastic undertones. Add attitude and eye-rolling energy.',
    image: khali,
    audioFile: khaliAudio,
    bgColor: 'linear-gradient(135deg, #d4a657, #9e7b34)'
  },
  {
    narrator: 'amelia',
    label: 'Amelia',
    tone: 'Bedtime_Storyteller',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak in a gentle, soothing bedtime storyteller voice that makes listeners feel cozy and sleepy.',
    image: amelia,
    audioFile: ameliaAudio,
    bgColor: 'linear-gradient(135deg, #f7faff, #e1ecfa)'
  },
  {
    narrator: 'harvey-quinn',
    label: 'Harvey Quinn',
    tone: 'Snappy_Sass_Machine',
    text: 'Take a deep breath in, hold it for a moment, and then slowly release. Feel the tension melting away with each breath.',
    instructions: 'Speak with quick, witty delivery and sarcastic undertones. Add attitude and eye-rolling energy.',
    image: quinn,
    audioFile: quinnAudio,
    bgColor: 'linear-gradient(135deg, #d4a657, #9e7b34)'
  },
  {
    narrator: 'dash',
    label: 'Dash',
    tone: 'Snappy_Sass_Machine',
    text: 'Great plan. I love the part where nobody explains what we are doing and somehow I am the dramatic one.',
    instructions: 'Speak with a sassy, witty, slightly whiny delivery. Add playful sarcasm, clever timing, and a tiny fantasy-elf attitude.',
    image: dash,
    audioFile: dashAudio,
    bgColor: 'linear-gradient(135deg, #e9f7dd, #9fd081)'
  },
  {
    narrator: 'britney',
    label: 'Britney',
    tone: 'Theatrical_Drama_Queen',
    text: 'Okay, wow. I am not being dramatic, I am just noticing literally everything.',
    instructions: 'Speak with a bright valley-girl vibe, playful reality TV drama, juicy gossip energy, and theatrical annoyance.',
    image: britney,
    audioFile: britneyAudio,
    bgColor: 'linear-gradient(135deg, #ffe6f1, #ffb56f)'
  },
  {
    narrator: 'malrog',
    label: 'Malrog',
    tone: 'Diabolical_Lord',
    text: 'Come closer, mortal. Let me see what your courage is made of.',
    instructions: 'Speak in a deep fantasy monster voice with cavernous resonance, slow pacing, and powerful final-boss presence.',
    image: malrog,
    audioFile: malrogAudio,
    bgColor: 'linear-gradient(135deg, #3b2b42, #17131d)'
  }
];

// Story style showcase data
export const styleData = [
  {
    id: '3d-cartoon',
    label: '3D Cartoon',
    description: 'Vibrant 3D animated characters with smooth surfaces and bright colors',
    image: style3DCartoon,
    bgColor: 'linear-gradient(135deg, #88cfff, #3f87c7)'
  },
  {
    id: 'childrens-storybook',
    label: "Children's Book",
    description: 'Flat 2D cartoon style perfect for classic children\'s storybooks',
    image: styleChildrensBook,
    bgColor: 'linear-gradient(135deg, #ffd89b, #f7b267)'
  },
  {
    id: 'minecraft',
    label: 'Classic Blocks',
    description: 'Minecraft-inspired blocky art style with cube-based aesthetics',
    image: styleMinecraft,
    bgColor: 'linear-gradient(135deg, #8bc34a, #689f38)'
  },
  {
    id: 'anime',
    label: 'Animation',
    description: 'Japanese anime-inspired art with expressive characters',
    image: styleAnime,
    bgColor: 'linear-gradient(135deg, #ffa8ac, #ff7a80)'
  },
  {
    id: 'photo-realism',
    label: 'Realistic',
    description: 'Incredibly realistic imagery that looks like photographs',
    image: stylePhotoRealism,
    bgColor: 'linear-gradient(135deg, #545454, #232323)'
  },
  {
    id: 'wool',
    label: 'Cozy Woolknit',
    description: 'Warm, textured wool and fabric designs with cozy handcrafted appeal',
    image: styleWool,
    bgColor: 'linear-gradient(135deg, #f5ebd9, #e6d7b8)'
  },
  {
    id: 'watercolor',
    label: 'Watercolor',
    description: 'Soft, artistic watercolor paintings with flowing brushstrokes',
    image: styleWatercolor,
    bgColor: 'linear-gradient(135deg, #c2eabb, #8fc36d)'
  },
  {
    id: 'pixel',
    label: '2D Game',
    description: 'Retro pixel art style reminiscent of classic video games',
    image: stylePixel,
    bgColor: 'linear-gradient(135deg, #d4a657, #9e7b34)'
  },
  {
    id: 'claymation',
    label: 'Claymation',
    description: 'Clay-like textures and stop-motion animation aesthetics',
    image: styleClaymation,
    bgColor: 'linear-gradient(135deg, #e8b545, #bf8923)'
  },
  {
    id: 'comic-book',
    label: 'Comic Book',
    description: 'Bold comic book style with vibrant colors and dynamic poses',
    image: styleComicBook,
    bgColor: 'linear-gradient(135deg, #d8e8ff, #9cc3ff)'
  },
  {
    id: 'sketch',
    label: 'B&W Sketch',
    description: 'Black and white pencil art style with detailed graphite work',
    image: styleSketch,
    bgColor: 'linear-gradient(135deg, #9e9e9e, #616161)'
  },
  {
    id: 'sugarpop',
    label: 'Sugarpop',
    description: 'Bright pop art cartoon style with vibrant dreamy colors',
    image: styleSugarpop,
    bgColor: 'linear-gradient(135deg, #ff6ec7, #f06292)'
  },
  {
    id: 'spray-paint',
    label: 'Spray Paint',
    description: 'Graffiti mural street art style with bold outlines and vibrant colors',
    image: styleSprayPaint,
    bgColor: 'linear-gradient(135deg, #ff9800, #f57c00)'
  },
  {
    id: 'crayon',
    label: 'Crayon',
    description: 'Childlike crayon coloring book style with playful waxy strokes',
    image: styleCrayon,
    bgColor: 'linear-gradient(135deg, #ffeb3b, #fdd835)'
  },
  {
    id: 'origami',
    label: 'Origami',
    description: 'Paper folded art style with geometric shapes and crisp creases',
    image: styleOrigami,
    bgColor: 'linear-gradient(135deg, #90caf9, #42a5f5)'
  },
  {
    id: 'ink-toon',
    label: 'Ink Toon',
    description: 'Colorful 2.5D cartoon painting with loose ink accents and bold silhouettes',
    image: styleInkToon,
    bgColor: 'linear-gradient(135deg, #ffb25f, #7c4dff)'
  },
  {
    id: 'hd-game',
    label: 'HD Game',
    description: 'Stylized premium video game key art with cinematic lighting and heroic polish',
    image: styleHDGame,
    bgColor: 'linear-gradient(135deg, #4ade80, #2563eb)'
  },
  {
    id: 'cozy-painting',
    label: 'Cozy Painting',
    description: 'Warm hand-painted story art with soft light, rich color, and gentle texture',
    image: styleCozyPainting,
    bgColor: 'linear-gradient(135deg, #f9c784, #d95d39)'
  }
];

// Helper function to generate audio JSON-LD
export const generateAudioJsonLd = (voices: any[]) => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": voices.map((voice, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "AudioObject",
        "name": `${voice.label} - ${voice.tone.replace(/_/g, ' ')}`,
        "description": voice.text,
        "contentUrl": `https://thefableapp.com/audio/${voice.narrator}.mp3`,
        "encodingFormat": "audio/mpeg"
      }
    }))
  });
};

// Helper function to generate music JSON-LD
export const generateMusicJsonLd = () => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "MusicRecording",
    "name": "Tonight I'll Have It All",
    "description": "A magical musical adventure featuring custom AI-generated songs and melodies for children's bedtime stories",
    "duration": "PT2M15S",
    "encodingFormat": "audio/mpeg",
    "genre": ["Children's Music", "Lullaby", "Musical Theater", "Orchestral Buildup"],
    "inLanguage": "en-US",
    "creator": {
      "@type": "Organization",
      "name": "Fable",
      "url": "https://thefableapp.com"
    },
    "isPartOf": {
      "@type": "CreativeWork",
      "name": "Fable Musical Stories",
      "description": "AI-generated musical bedtime stories with custom songs and melodies"
    },
    "keywords": ["AI music", "children's songs", "bedtime music", "musical storytelling", "custom lullabies"]
  });
};

// Helper function to generate breadcrumb JSON-LD
export const generateBreadcrumbJsonLd = (currentHash?: string, breadcrumbName?: string) => {
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://thefableapp.com"
    }
  ];

  // Add route-specific breadcrumb if provided
  if (breadcrumbName && breadcrumbName !== 'Home') {
    breadcrumbItems.push({
      "@type": "ListItem",
      "position": 2,
      "name": breadcrumbName,
      "item": `https://thefableapp.com${window.location.pathname}`
    });
  }

  // Add current section if hash is present
  if (currentHash) {
    const sectionNames: Record<string, string> = {
      "ai-story-generator": "AI Story Generator",
      "what-our-users-say": "Customer Reviews",
      "featured-in": "Featured In Media",
      "fable-demo-video": "Fable Immersive Video",
      "make-it-musical": "Musical Stories",
      "ai-narrators": "AI Narrators",
      "dialog-mode": "Dialog Mode",
      "let-fable-create-story": "Story Examples",
      "story-styles": "Story Styles",
      "languages": "Languages",
      "how-it-works": "How It Works",
      "follow-us": "Social Media",
      "download-app": "Download App",
      "faq": "Frequently Asked Questions",
      "explore-more": "Explore More"
    };

    const sectionName = sectionNames[currentHash];
    if (sectionName) {
      breadcrumbItems.push({
        "@type": "ListItem",
        "position": breadcrumbItems.length + 1,
        "name": sectionName,
        "item": `https://thefableapp.com#${currentHash}`
      });
    }
  }

  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  });
};

// Helper function to generate page sections/navigation JSON-LD
export const generatePageSectionsJsonLd = () => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "url": "https://thefableapp.com",
    "name": "Fable AI Story Generator",
    "description": "Create personalized AI bedtime stories for kids",
    "mainEntity": {
      "@type": "SoftwareApplication",
      "name": "Fable",
      "applicationCategory": "EntertainmentApplication",
      "operatingSystem": "iOS, Android"
    },
    "hasPart": [
      {
        "@type": "WebPageElement",
        "name": "AI Story Generator",
        "url": "https://thefableapp.com#ai-story-generator",
        "description": "Introduction to Fable's AI story generation features"
      },
      {
        "@type": "WebPageElement", 
        "name": "Customer Reviews",
        "url": "https://thefableapp.com#what-our-users-say",
        "description": "What our users say about Fable"
      },
      {
        "@type": "WebPageElement",
        "name": "Featured In Media",
        "url": "https://thefableapp.com#featured-in",
        "description": "Media coverage and press mentions"
      },
      {
        "@type": "WebPageElement",
        "name": "Fable Immersive Video",
        "url": "https://thefableapp.com#fable-demo-video",
        "description": "Watch how Fable brings stories to life - be the main character of your own story"
      },
      {
          "@type": "WebPageElement",
          "name": "Musical Stories",
          "url": "https://thefableapp.com#make-it-musical",
          "description": "Transform your stories into magical musical adventures with custom songs and melodies"
        },
      {
        "@type": "WebPageElement",
        "name": "AI Narrators",
        "url": "https://thefableapp.com#ai-narrators",
        "description": "Meet our expressive AI voice narrators"
      },
      {
        "@type": "WebPageElement",
        "name": "Dialog Mode",
        "url": "https://thefableapp.com#dialog-mode",
        "description": "Let our high-quality AI narrators tell the story with expressive voices and immersive sound effects"
      },
      {
        "@type": "WebPageElement",
        "name": "Story Examples",
        "url": "https://thefableapp.com#let-fable-create-story",
        "description": "Examples of AI-generated stories"
      },
      {
        "@type": "WebPageElement",
        "name": "Story Styles",
        "url": "https://thefableapp.com#story-styles",
        "description": "Create your stories in any visual style from 3D cartoons to watercolor paintings"
      },
      {
        "@type": "WebPageElement",
        "name": "Global Reach",
        "url": "https://thefableapp.com#global-reach",
        "description": "Discover how families around the world are using Fable to create magical bedtime stories"
      },
      {
        "@type": "WebPageElement",
        "name": "How It Works",
        "url": "https://thefableapp.com#how-it-works",
        "description": "Two ways to create: Fable Go for a few simple choices, or Fable Gambit for conversational story building."
      },
      {
        "@type": "WebPageElement",
        "name": "Social Media",
        "url": "https://thefableapp.com#follow-us",
        "description": "Follow us on social media"
      },
      {
        "@type": "WebPageElement",
        "name": "Download App",
        "url": "https://thefableapp.com#download-app",
        "description": "Download the Fable app"
      },
      {
        "@type": "WebPageElement",
        "name": "Frequently Asked Questions",
        "url": "https://thefableapp.com#faq",
        "description": "Common questions and answers about Fable"
      },
      {
        "@type": "WebPageElement",
        "name": "Explore More",
        "url": "https://thefableapp.com#explore-more",
        "description": "Explore all Fable features and story types"
      }
    ]
  });
};

// FAQ Schema for Rich Snippets
export const generateFAQJsonLd = (faqData: any[]) => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.preview
      }
    }))
  });
};

// Organization Schema
export const generateOrganizationJsonLd = () => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Fable",
    "url": "https://thefableapp.com",
    "logo": "https://thefableapp.com/fable-icon.png?v=butterfly-20260916",
    "description": "AI story generator creating personalized bedtime stories for kids featuring advanced AI narrators, musical modes, and beautiful illustrations",
    "sameAs": [
      "https://www.tiktok.com/@thefableapp",
      "https://www.instagram.com/thefableapp",
      "https://www.youtube.com/@thefableapp",
      "https://www.linkedin.com/company/the-fable-app",
      "https://x.com/TheFableApp"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Support",
      "email": "support@thefableapp.com"
    }
  });
};

// HowTo Schema for "How Fable AI Works" section
export const generateHowToJsonLd = () => JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name: 'How to create a story with Fable Go',
  description: 'Choose a character, describe your idea and let Fable create an illustrated story with voices.',
  step: [
    { '@type': 'HowToStep', position: 1, name: 'Choose your character', text: 'Dream up someone new or put yourself in the story. Add photos to create a character who looks like you.', url: 'https://thefableapp.com/#fable-go-step-1' },
    { '@type': 'HowToStep', position: 2, name: 'Tell us your idea', text: 'A quick bedtime adventure or a world of your own. Describe the story you want to tell.', url: 'https://thefableapp.com/#fable-go-step-2' },
    { '@type': 'HowToStep', position: 3, name: 'Enjoy your story', text: 'Let Fable bring it to life with illustrations and narration. Choose a narrator, design a new voice or use your own.', url: 'https://thefableapp.com/#fable-go-step-3' },
  ],
});

// Descriptive app identity. Store ratings remain attributed visible content;
// Google review markup requires eligible reviews collected on this site.
export const generateSoftwareAppJsonLd = () => JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  '@id': 'https://thefableapp.com/#app',
  name: 'Fable - AI Story Generator',
  description: 'Create personalized illustrated stories with character voices, narration, music, and video on web, iOS, and Android.',
  applicationCategory: 'EntertainmentApplication',
  applicationSubCategory: 'Books',
  operatingSystem: 'Web, iOS, Android',
  url: 'https://thefableapp.com/',
  sameAs: storeRatings.stores.map(store => store.url),
  downloadUrl: 'https://thefableapp.onelink.me/wYsE/ldw8jl1m',
});
